import { Directive, Input, ElementRef, OnInit, Renderer2 } from '@angular/core';

@Directive({
    selector: '[readwriteAccess]',
    standalone: false
})
export class KeyRoleDirective implements OnInit {
  roles = "spc-support"; //these roles have all tha access rest other restricted
  constructor(private el: ElementRef, private renderer: Renderer2) { }

  ngOnInit() {
    const userRole = localStorage.getItem('userRole'); // Assuming you have a method to get the user role 
    const hostElement = this.el?.nativeElement;

    // In a few unit-test render paths, the directive can be instantiated without
    // a concrete host element. Guard to avoid runtime errors in those cases.
    if (!hostElement) {
      return;
    }

    const hasAccess = !!userRole && this.roles.includes(userRole);
    if (!hasAccess) {
      this.renderer.setStyle(hostElement, 'pointer-events', 'none');
      this.renderer.addClass(hostElement, 'blurred');
    }
  }

}
